import { text_mod_55 } from "../text/Text.js";

export const module55 = {
  title: "Числівник як частина мови. Питання числівника",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_55,
    },
  ],
};
